/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tab_DocumentsInputs */

const cs_clients_tab_documents = /** @type {(inputs: Clients_Tab_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty`)
};

const en_clients_tab_documents = /** @type {(inputs: Clients_Tab_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Clients_Tab_DocumentsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tab_documents = /** @type {((inputs?: Clients_Tab_DocumentsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tab_DocumentsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tab_documents(inputs)
	return cs_clients_tab_documents(inputs)
});